<div class="d-flex flex-column h-100">
  <div class="offcanvas-header d-flex justify-content-between align-items-center">
    <div class="">
    </div>
    <div>
      <button type="button" class="btn-close" (click)="closeOpeningBank()"></button>
    </div>
  </div>
  <div class="offcanvas-body">
    <hr>

    <h5 class="modal-title text-dark fw-bold mt-3">
      {{'COMMON.ACCESS_PERIOD' | translate}}
    </h5>
    <form [formGroup]="accessPeriodForm">
      <div class="bg-light p-3 rounded-2 mt-3">
        <div class="form-floating input-group mb-3">
          <input title="time" class="form-control" formControlName="accessFrom" [plugins]="plugins"
            [options]="flatpickrAccessFromOptions" [dateFormat]="'Y-m-d'" type="text" mwlFlatpickr [enableTime]="false"
            mode="single" [class.is-invalid]="accessPeriod['accessFrom'].touched && accessPeriod['accessFrom'].errors"
            placeholder="Transaction Period">
          <label class="form-label mb-0">
            {{'COMMON.ACCESS_FROM' | translate}}
          </label>
          <div class="input-group-text text-primary">
            <i class="ri-calendar-2-line"></i>
          </div>
        </div>
        @if (accessPeriod['accessFrom'].errors) {
        <div>
          @if (accessPeriod['accessFrom']?.touched && accessPeriod['accessFrom'].errors?.['required']) {
          <div class=" text-danger">
            {{'VALIDATIONS.ACCESS_FROM_REQUIRED' | translate}}
          </div>
          }
        </div>
        }
        <hr />
        <div class="form-floating input-group mb-3">
          <input title="time" class="form-control" formControlName="accessTo" [plugins]="plugins"
            [options]="flatpickrAccessToOptions" [dateFormat]="'Y-m-d'" type="text" mwlFlatpickr [enableTime]="false"
            mode="single" [class.is-invalid]="accessPeriod['accessTo'].touched && accessPeriod['accessTo'].errors"
            placeholder="Transaction Period">
          <label class="form-label mb-0">
            {{'COMMON.ACCESS_TO' | translate}}
          </label>
          <div class="input-group-text text-primary">
            <i class="ri-calendar-2-line"></i>
          </div>
        </div>
        @if (accessPeriod['accessTo'].errors) {
        <div>
          @if (accessPeriod['accessTo']?.touched && accessPeriod['accessTo'].errors?.['required']) {
          <div class=" text-danger">
            {{'VALIDATIONS.ACCESS_TO_REQUIRED' | translate}}
          </div>
          }
        </div>
        }
        <p class="mt-3 mb-0 fs-12 text-black-50">
          {{'OPEN_BANKING.REVOKE_CONSENT_HINT' | translate}}
        </p>
      </div>
    </form>
    <div class="bg-soft-info border-1 rounded-1 p-2 mt-4 fs-12 text-black-50">
      {{'OPEN_BANKING.CONSENT_NOTE' | translate}}
    </div>
  </div>
  @if (!termsAndConditionsChecked) {
  <div class="alert alert-danger alert-dismissible alert-label-icon rounded-label fade show mx-2" role="alert">
    <i class="ri-error-warning-line label-icon"></i>
    <b>{{'VALIDATIONS.CHECK_TERMS_AND_CONDITIONS' | translate}}</b>
  </div>
  }
  <div class="offcanvas-footer p-3 bg-light">
    <div class="fs-12 text-muted mb-2">
      <input class="form-check-input me-1" type="checkbox" [(ngModel)]="termsAndConditionsChecked" />
      {{ 'OPEN_BANKING.CONSENT_TERMS_1' | translate }}
      <strong>{{'COMMON.BANK_ACCOUNTS' | translate}}</strong>
      {{ 'OPEN_BANKING.CONSENT_TERMS_2' | translate }} <a routerLink="/terms-and-conditions" target="_blank"
        rel="noopener" class="text-primary text-decoration-underline fs-14 fw-medium">
        {{'COMMON.TERMS_OF_USE' | translate}}
      </a>,
      <a routerLink="/privacy-policy" target="_blank" rel="noopener"
        class="text-primary text-decoration-underline fs-14 fw-medium">
        {{'COMMON.PRIVACY_POILICY' | translate}}
      </a>
    </div>
    <button type="button" [disabled]="!accessPeriodForm.valid || !termsAndConditionsChecked"
      class="btn btn-primary w-100" (click)="connectBank()">
      {{'COMMON.CONTINUE'| translate}}
    </button>
  </div>
</div>